import logger from '../../lib/helpers/logger';
import { useStore } from '../../lib/hooks/useStore';
import { ComponentAction } from '../../lib/typegen/component-action';
import { ComponentData } from '../../lib/typegen/component-data';
import { KeyValue } from '../../lib/typegen/key-value';
import { ModalContent } from '../../lib/typegen/modal-content';
import GenericButton from '../button-generic';
import style from './style.module.scss';

export default function DynamicButton({
	action,
	data,
	theme,
	handleNavigation,
	...props
}: {
	action: ComponentAction;
	data: ComponentData;
	theme?: string;
	handleNavigation?: (pageId: string, params?: KeyValue[] | null) => void;
}) {
	const {
		configStore: { getString },
	} = useStore();
	const buttonThemeClass = theme ? (style[`button--${theme}` as keyof typeof style] as string) : '';
	const buttonFullWidthClass = data.fullWidth ? (style[`button--full-width` as keyof typeof style] as string) : '';

	const handleClick = (action: ComponentAction, data: ComponentData) => {
		switch (action) {
			case ComponentAction.Navigate:
				if (typeof handleNavigation === typeof Function) {
					handleNavigation?.(data.target || '#unknown', data.params);
				}
				break;
			case ComponentAction.Script:
				// Use new Function() instead of eval() to avoid some minification issues and security warnings
				if (data.script) {
					try {
						const dynamicScript = new Function(data.script);
						dynamicScript();
					} catch (e) {
						logger.debug.error('Error executing dynamic script:', e);
					}
				} else {
					logger.debug.log('No script defined.');
				}
				break;
			case ComponentAction.OpenModal:
				openModal(data.modalContent || { title: 'Error', body: 'No modal content defined' });
				break;
			default:
				logger.debug.log('Unsupported action: ', action);
				break;
		}
	};

	const openModal = (modalContent: ModalContent) => {
		alert('Open modal goes here');
		logger.debug.log('Modal content', modalContent);
	};

	return (
		<GenericButton
			icon={data.appIconType ?? undefined}
			innerText={data.textContent ? getString(data.textContent) : ''}
			className={[style.button, buttonThemeClass, buttonFullWidthClass].join(' ')}
			isFullWidth={data.fullWidth}
			isGrowHorizontally={!['done', 'agree'].includes(data.textContent?.toLowerCase() ?? '')}
			onClick={() => handleClick(action, data)}
			{...props}
		/>
	);
}
